import styled from 'styled-components'

export const CashFlowWrapper = styled.div`
  //img {
  //    width: 100%;
  //    height: auto;
  //}
`
export const CashFlowItemList = styled.div`
    padding: 48px 16px 16px 16px;
    display: flex;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;
    @media only screen and (max-width: 1300px) {
        &:before {
            content: '';
            flex-basis: 100%; /* Tạo một ngắt dòng ảo chiếm toàn bộ chiều rộng */
            order: 2; /* Đảm bảo ngắt dòng xảy ra sau phần tử đầu tiên */
        }
    }
    @media only screen and (max-width: 768px) {
        flex-direction: column;
    }
`
export const CashFlowItem = styled.div`
    padding: 64px 24px;
    border-radius: 240px;
    border: 1px solid #ccc;
    background-color: #f2f2f2;
    text-align: center;
    width: 280px;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);

    img {
        height: 240px;
        width: 240px;
        @media only screen and (max-width: 768px) {
            height: 64px;
            width: auto;
        }
    }

    @media only screen and (max-width: 1300px) {
        &:nth-child(2) {
            order: 3; /* Đặt phần tử thứ 2 xuống dòng */
        }

        &:nth-child(3) {
            order: 4; /* Đặt phần tử thứ 2 xuống dòng */
        }
    }
    @media only screen and (max-width: 768px) {
        padding: 16px;
        width: auto;
        display: flex;
    }
`
export const CashFlowItemTitle = styled.div`
 width: 100%;
`
export const CashFlowItemDescription = styled.div`
  color: #4b4b4b;
  max-width: 100%; /* Chiều rộng tối đa bằng 100% của parent */
  overflow-wrap: break-word; /* Đảm bảo từ được ngắt khi cần thiết */
  word-wrap: break-word; /* Tương thích cũ hơn cho ngắt từ */
  word-break: break-word; /* Hỗ trợ ngắt từ ở các trường hợp cụ thể */
  font-size: 20px;
  margin: ${props => props.margin};
`
